import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, TrendingDown, ShieldAlert } from 'lucide-react';
import type { DashboardMetrics } from '../utils/calculations';
import { formatCurrency } from '../utils/calculations';
interface CriticalThresholdsProps {
  metrics: DashboardMetrics;
}
export function CriticalThresholds({
  metrics
}: CriticalThresholdsProps) {
  // Visual bar: show CPA ideal as percentage of break-even
  const cpaRatio = metrics.cpaBreakEven > 0 ? Math.min(metrics.cpaIdeal / metrics.cpaBreakEven * 100, 100) : 0;
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} transition={{
    duration: 0.5,
    delay: 0.3
  }} className="glass-card p-6 h-full flex flex-col border-danger-red/20" data-id="element-15">
      <div className="flex items-center gap-3 mb-6" data-id="element-16">
        <div className="p-2 bg-danger-red/10 rounded-lg" data-id="element-17">
          <AlertTriangle className="w-5 h-5 text-danger-red" data-id="element-18" />
        </div>
        <h2 className="text-sm font-bold tracking-widest text-danger-red uppercase" data-id="element-19">
          Umbrales Críticos
        </h2>
      </div>

      <div className="space-y-6 flex-grow flex flex-col justify-center" data-id="element-20">
        {/* CPA Break-even */}
        <div className="relative" data-id="element-21">
          <div className="flex justify-between items-end mb-2" data-id="element-22">
            <div data-id="element-23">
              <h3 className="text-xs font-bold text-white/60 uppercase mb-1" data-id="element-24">
                CPA Break-Even (Meta)
              </h3>
              <div className="text-2xl font-black text-danger-red drop-shadow-[0_0_8px_rgba(255,68,68,0.5)]" data-id="element-25">
                {formatCurrency(metrics.cpaBreakEven)}
              </div>
            </div>
            <TrendingDown className="w-5 h-5 text-danger-red/70 mb-1" data-id="element-26" />
          </div>
          <div className="w-full h-1.5 bg-white/10 rounded-full overflow-hidden" data-id="element-27">
            <div className="h-full bg-gradient-to-r from-cyber-green via-yellow-400 to-danger-red relative transition-all duration-500" style={{
            width: `${cpaRatio}%`
          }} data-id="element-28">
              <div className="absolute right-0 top-0 bottom-0 w-1 bg-white shadow-[0_0_10px_white]" data-id="element-29"></div>
            </div>
          </div>
          <div className="flex justify-between mt-1.5" data-id="element-30">
            <span className="text-[10px] text-cyber-green/60 font-medium" data-id="element-31">
              CPA Ideal: {formatCurrency(metrics.cpaIdeal)}
            </span>
            <span className="text-[10px] text-danger-red/60 font-medium uppercase tracking-wider" data-id="element-32">
              Límite de pérdida
            </span>
          </div>
        </div>

        <div className="h-px w-full bg-white/5" data-id="element-33"></div>

        {/* ROAS Break-even */}
        <div data-id="element-34">
          <div className="flex items-center gap-2 mb-2" data-id="element-35">
            <ShieldAlert className="w-4 h-4 text-white/50" data-id="element-36" />
            <h3 className="text-xs font-bold text-white/60 uppercase" data-id="element-37">
              ROAS Break-Even
            </h3>
          </div>
          <div className="flex items-baseline gap-2" data-id="element-38">
            <span className="text-3xl font-bold text-white" data-id="element-39">
              {metrics.roasBreakEven.toFixed(2)}
            </span>
            <span className="text-xs text-white/40 font-medium" data-id="element-40">
              Mínimo requerido
            </span>
          </div>
        </div>
      </div>
    </motion.div>;
}